export enum ReviewingParty {
  Redo = "redo",
  Merchant = "merchant",
}
